import classNames from "classnames/bind";
import styles from "./ImageObject.module.css";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import axios from "axios";
import image from "../../assets/images/NoConnect.png"
import { Image } from "antd";

const cx = classNames.bind(styles);

const ImageObject = ({ src, type = "face", height, maxWidth }) => {
    const [loading, setLoading] = useState(true)
    const [srcImage, setSrcImage] = useState("")

    useEffect(() => {
        let count = 0
        const getImage = async () => {
            try {
                await axios.get(src);
                setSrcImage(src);
                setLoading(false);
            } catch (error) {
                if (count <= 3) {
                    count++;
                    setTimeout(() => {
                        getImage();
                    }, 1000);
                } 
            }
        }
        getImage();
    }, [])
    return (
        <div className={cx('image-avatar')}>
            <Image style={type === "plate" ? { height: height || 40, maxWidth: maxWidth || 'none' } : { height: height || '100%' }}
                src={srcImage?.length > 0 ? srcImage : ""} loading="lazy" />
            {loading && <div className={cx('loading')}><Loading width={16} /></div>}
        </div>
    )
}

export default ImageObject;